import { useEffect, useState } from 'react'
import { api, type ProtokollEintrag } from '../api'
import { zeitpunkt } from '../format'
import { Fehlermeldung, fehlerText } from './gemeinsam'

export function Protokoll() {
  const [eintraege, setEintraege] = useState<ProtokollEintrag[]>([])
  const [fehler, setFehler] = useState<string | null>(null)

  useEffect(() => {
    api.protokoll().then(setEintraege).catch((e) => setFehler(fehlerText(e)))
  }, [])

  return (
    <section className="karte">
      <h2>Protokoll</h2>
      <Fehlermeldung fehler={fehler} />
      <table>
        <thead>
          <tr>
            <th>Zeitpunkt</th>
            <th>Rubrik</th>
            <th>Eintrag</th>
          </tr>
        </thead>
        <tbody>
          {eintraege.map((e) => (
            <tr key={e.id}>
              <td>{zeitpunkt(e.zeitpunkt)}</td>
              <td>{e.rubrik}</td>
              <td>{e.eintrag}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  )
}
